import React from 'react'
import Navbar from './Navbar'
import './About.css'

export default function About() {
  return (
    <div className='About'>
      <Navbar />

      <div style={{ marginTop: 'calc(5vh + 50px)' }}></div>

      <div className='About-Explanation'>
        <p>
          Introducing HOPE, a suite of free and open-source tools designed to
          help students, educators, and lifelong learners improve their learning
          experience. Our mission is to identify common challenges faced by
          learners and provide practical solutions through software that is
          accessible and free for everyone.
          <br />
          <br />
          At HOPE, we believe that learning should be an enjoyable and
          fulfilling experience. However, we understand that it can be
          challenging to stay focused and motivated, especially when faced with
          a plethora of distractions and time constraints. That's why we have
          created a range of tools that aim to enhance the learning process and
          make it more efficient and effective.
          <br />
          <br />
          Our projects are diverse, but they all share a common theme of
          identifying problems in the learning process and finding innovative
          solutions. Whether it's an app that helps you find data on any country
          or a tool that graphs world progress, we aim to provide practical
          solutions that make learning easier and more accessible for everyone.
          <br />
          <br />
          What sets HOPE apart is our commitment to open-source software. We
          believe that everyone should have access to the tools they need to
          learn and grow, regardless of their financial situation. That's why we
          have made all our tools available for free, with the aim of creating a
          community of learners who can share their knowledge and experiences to
          help each other succeed.
          <br />
          <br />
          At HOPE, we are dedicated to helping learners of all ages and
          backgrounds reach their full potential. We believe that everyone
          deserves the opportunity to learn, grow, and achieve their goals, and
          our suite of tools is designed to make that possible. So, join us
          today and discover a new world of learning possibilities with HOPE. If
          you share our passion for learning and are interested in contributing
          to the HOPE project, we would love to hear from you! We believe that
          collaboration and community involvement are key to the success of our
          project, and we welcome any contributions or suggestions that you may
          have.
          <br />
          <br />
          If you are a developer, designer, or simply interested in helping out,
          please visit our GitHub page to learn more about our projects and how
          you can get involved. On our GitHub page, you will find information on
          our current projects, as well as instructions on how to contribute to
          the project.
        </p>
      </div>
    </div>
  )
}
